// https://github.com/xieyezi/sku-algorithm
import * as React from "react";
import SpecAdjoinMatrix from "./spec-adjoin-matrix";
import { useAppSelector } from '../../redux/hooks';
import SkuList from './sku-list';
import "./index.scss";

const { useState,useMemo } = React;

const Spec = ( props: any ) => {
    const { skuAttrs, type } = props;

    const infoMap = useAppSelector( state =>  state.sku[type].map);

    // 无sku
    if (JSON.stringify(infoMap) === JSON.stringify({})) return null;
    
    // 默认选中
    const initSelected: any[] | (() => any[]) = [];
    const initialState = {
        // 转换sku组合
        skuCombinationList: Object.keys( infoMap ).map( i => ( {
            id: infoMap[i].id,
            specs: i.split( ';' ).filter( s => s )
        } ) ),
        // 整合sku
        skuList: skuAttrs.map( (i: { name: any; values: any[]; id: any; }) => ( {
            title: i.name,
            list: i.values.map( (v: { selected: boolean; id: any; }) => {
                // 首次默认选中
                if ( v.selected === true) {
                    initSelected.push( `${i.id}:${v.id}` );
                }
                return `${i.id}:${v.id}`
            } )
        } ) )
    };

    const { skuList,skuCombinationList } = initialState;

    // 已选择的规格，长度为规格列表的长度
    const [specsS,setSpecsS] = useState( initSelected );

    // 创建一个规格矩阵
    const specAdjoinMatrix = useMemo( () => new SpecAdjoinMatrix( skuList,skuCombinationList ),[skuList,skuCombinationList] );

    // 获得可选项表
    const optionSpecs = specAdjoinMatrix.getSpecscOptions( specsS );

    const handleClick = function ( bool: boolean,text: string,index: number ) {
        // 排除可选规格里面没有的规格
        if ( specsS[index] !== text && !bool ) return;
        // 根据text判断是否已经被选中了
        specsS[index] = specsS[index] === text ? "" : text;
        setSpecsS( specsS.slice() );
    };

    return (
        <div className="sku-body">
            <SkuList {...props} skuInfoMap={infoMap} handleClick={handleClick} optionSpecs={optionSpecs} specsS={specsS} />
        </div>
    );
};

export default Spec;